import { useState } from 'react';
import { useLang } from '../LangContext';

const sectionsIT = [
  {
    id: 'chi',
    title: 'Chi cerchiamo',
    content: `Rural Design Amiata cerca artisti, designer, architetti, artigiani, performer che vogliano rispondere alla sfida del cambiamento - non solo climatico - attraverso opere, progetti, interventi capaci di:

→ Interrogare il presente con sguardo critico
→ Immaginare futuri possibili e desiderabili
→ Attrezzare le comunità agli scenari che ci attendono
→ Dialogare con il territorio del Monte Amiata e la sua storia mineraria`
  },
  {
    id: 'categorie',
    title: 'Categorie ammesse',
    content: `La call è aperta a proposte nelle seguenti discipline:

· Architettura / Progettazione ambientale
· Land Art / Interventi site-specific
· Design industriale / di prodotto
· Fashion Design
· Arti visive (scultura, installazione, pittura)
· Grafica / Media digitali
· Artigianato (legno, ceramica, metallo, fibra)
· Audiovisivo / Sound design
· Arti performative`
  },
  {
    id: 'requisiti',
    title: 'Requisiti di partecipazione',
    content: `Chi può partecipare
· Tutti senza limiti di età
· Singolarmente o in gruppo (collettivi artistici, studi, team multidisciplinari)
· La partecipazione è gratuita

Cosa si può presentare
· Fino a 3 opere per candidato/gruppo
· Opere inedite e non precedentemente esposte
· Progetti da realizzare (con concept e rappresentazione del risultato finale)
· Opere già realizzate (con documentazione fotografica)

Vincoli tecnici
Le opere dovranno essere compatibili con gli spazi del Parco Nazionale delle Miniere del Monte Amiata, rispettare le specifiche tecniche e essere installabili entro 5 giorni prima dell'apertura della rassegna.`
  },
  {
    id: 'specifiche',
    title: 'Specifiche tecniche',
    content: `Per progetti da realizzare — allegare al form:
· Concept descrittivo (max 3.000 caratteri)
· Render, schizzi o disegni tecnici
· Scheda tecnica: dimensioni, materiali, modalità di installazione, fabbisogni
· Budget indicativo di realizzazione (se pertinente)
· Dichiarazione di fattibilità
Formati accettati: PDF, JPG, PNG, mp3, mp4 (max 10MB per file)

Per opere già realizzate — allegare al form:
· Descrizione dell'opera (max 2.000 caratteri): titolo, anno, concept
· Documentazione fotografica professionale (minimo 3 immagini ad alta risoluzione)
· Scheda tecnica: dimensioni, materiali, peso, modalità di trasporto e installazione
· Condizioni di conservazione e eventuali esigenze espositive
Formati accettati: JPG, PNG, mp3, mp4 (min. 300dpi, max 10MB per file)

Per interventi site-specific / Land Art:
· Indicare se è richiesto sopralluogo preliminare
· Mappa/planimetria dell'intervento nel contesto del sito
· Documentazione dell'impatto ambientale (preferibilmente reversibile o compostabile)
· Eventuali autorizzazioni necessarie

Per performance:
· Scaletta/drammaturgia (max 2.000 caratteri)
· Video teaser o documentazione di performance precedenti (link Vimeo/YouTube)
· Rider tecnico: esigenze spazio, audio, luci, durata
· Numero di repliche proposte durante la rassegna`
  },
  {
    id: 'come',
    title: 'Come partecipare',
    content: `1. Compila il form online su www.ruraldesign.art con:
· Dati anagrafici (nome, cognome, data di nascita, residenza)
· Contatti (email, telefono, sito web/portfolio, social)
· Tipologia di partecipazione (individuale/collettiva)
· Categoria di appartenenza
· Titolo dell'opera/progetto
· Descrizione e concept
· File allegati (immagini, render, audio/video)

2. Allega i materiali richiesti seguendo le specifiche tecniche.

3. Riceverai una email di conferma di avvenuta ricezione della candidatura.`
  },
  {
    id: 'scadenze',
    title: 'Scadenze importanti',
    content: `11 LUGLIO 2026 ore 23:59 — Deadline candidature (CET)
20 LUGLIO 2026 — Annuncio artisti selezionati
03 AGOSTO 2026 — Consegna e installazione opere
08–21 AGOSTO 2026 — Rural Design Amiata 2026`
  },
  {
    id: 'selezione',
    title: 'Processo di selezione',
    content: `Le opere verranno selezionate dalla curatela di Amiata Rural Design sulla base di:
· Coerenza con il tema "Heavy Weather / Intemperie"
· Qualità artistica e progettuale
· Originalità e capacità di interrogare il presente
· Fattibilità tecnica e logistica
· Dialogo con il territorio e le location del Parco delle Miniere
· Impatto potenziale sul pubblico e sulla comunità

I nomi degli artisti selezionati saranno resi noti entro il 20 luglio 2026 tramite il sito, i canali social e email diretta a ciascun candidato.`
  },
  {
    id: 'offriamo',
    title: 'Cosa offriamo',
    content: `Per tutti gli artisti selezionati:
✓ Esposizione presso il Parco Nazionale delle Miniere del Monte Amiata
✓ Pubblicazione nel catalogo ufficiale della rassegna (edizione cartacea e digitale)
✓ Visibilità attraverso i canali di comunicazione di Rural Design (sito, social, comunicati stampa, media partner)
✓ Documentazione professionale delle opere durante la rassegna
✓ Networking con la comunità artistica, curatoriale e del design rurale
✓ Assicurazione delle opere durante il periodo espositivo

Supporto alla realizzazione (dove possibile):
· Supporto logistico per installazione
· Contributo materiali (per interventi site-specific o opere da realizzare)
· Rimborso spese di viaggio/soggiorno (da valutare caso per caso)

Questi aspetti verranno concordati individualmente dopo la comunicazione dei risultati.`
  },
  {
    id: 'location',
    title: 'Location disponibili',
    content: `Le opere potranno essere esposte nelle location del Parco Nazionale delle Miniere del Monte Amiata:
· Gallerie minerarie storiche
· Spazi industriali recuperati
· Percorsi naturalistici e boschi
· Piazze e spazi pubblici nei borghi minerari
· Strutture espositive indoor ed outdoor

In fase di candidatura è possibile indicare preferenze sulla location. La curatela valuterà l'assegnazione finale in base alla natura dell'opera e alle caratteristiche degli spazi.`
  },
  {
    id: 'esclusione',
    title: 'Cause di esclusione',
    content: `I progetti verranno automaticamente esclusi se:
❌ Pervengono oltre i termini di consegna (11 luglio 2026, ore 23:59)
❌ Non sono conformi alle specifiche tecniche richieste
❌ Sono ritenuti fuori tema rispetto alla call 2026 "Heavy Weather / Intemperie"
❌ Contengono materiali protetti da copyright senza liberatoria
❌ Presentano contenuti offensivi, discriminatori o illegali`
  },
  {
    id: 'diritti',
    title: 'Diritti e utilizzo delle opere',
    content: `Gli autori sono gli esclusivi titolari dei diritti di proprietà delle proprie opere.

Partecipando, gli autori accettano:
· L'esposizione temporanea delle opere per la durata della rassegna
· L'utilizzo delle immagini per promozione non commerciale di RU.DE., catalogo, sito web e social media, rassegna stampa

L'organizzazione NON può utilizzare le opere per scopi commerciali, vendita a terzi o modifiche senza consenso scritto.

Al termine della rassegna le opere dovranno essere ritirate entro 15 giorni dalla chiusura. L'organizzazione non si assume responsabilità per opere non ritirate entro i termini.`
  },
  {
    id: 'faq',
    title: 'Domande frequenti',
    content: `Posso partecipare con più opere?
Sì, ciascun candidato o gruppo può proporre una o più opere.

Ci sono limiti di età?
No, la call è aperta a tutti senza limiti di età.

Devo sostenere costi per partecipare?
La partecipazione è gratuita. Eventuali costi di produzione, trasporto e installazione sono a carico dell'artista, salvo diversi accordi concordati dopo la selezione.

Posso candidare un'opera già esposta altrove?
No, sono ammesse solo opere inedite.

Devo visitare le location prima di candidarmi?
Non è obbligatorio. Se selezionato, potrai concordare un sopralluogo con l'organizzazione.

Cosa succede se la mia opera richiede energia elettrica o altri supporti tecnici?
Indicalo nella scheda tecnica. La curatela valuterà la fattibilità in fase di selezione.

Posso modificare la mia candidatura dopo l'invio?
Puoi inviare integrazioni via email a cfa@ruraldesign.art entro la deadline dell'11 luglio.

Come saprò se la mia opera è stata selezionata?
Riceverai una comunicazione via email entro il 20 luglio 2026. I nomi saranno pubblicati sul sito e sui canali social.`
  },
];

const sectionsEN = [
  {
    id: 'chi',
    title: 'Who we are looking for',
    content: `Rural Design Amiata seeks artists, designers, architects, craftspeople and performers who want to respond to the challenge of change through works, projects and interventions capable of:

→ Questioning the present with a critical eye
→ Imagining possible and desirable futures
→ Equipping communities for the scenarios ahead
→ Engaging with the Monte Amiata territory and its mining history`
  },
  {
    id: 'categorie',
    title: 'Eligible categories',
    content: `The call is open to proposals in the following disciplines:

· Architecture / Environmental design
· Land Art / Site-specific interventions
· Industrial / product design
· Textile / fashion design
· Visual arts (sculpture, installation, painting)
· Graphics / Digital media
· Crafts (wood, ceramics, metal, fibre)
· Audiovisual / Sound design
· Performing arts`
  },
  {
    id: 'requisiti',
    title: 'Participation requirements',
    content: `Who can apply
· Everyone, no age limit
· Individually or as a group (collectives, studios, multidisciplinary teams)
· Participation is free

What can be submitted
· Up to 3 works per applicant/group
· Unpublished works not previously exhibited
· Projects to be realised (with concept and representation of the final result)
· Already completed works (with photographic documentation)

Technical constraints
Works must be compatible with the spaces of the Parco Nazionale delle Miniere del Monte Amiata, comply with the technical specifications below, and be ready for installation at least 5 days before the opening.`
  },
  {
    id: 'specifiche',
    title: 'Technical specifications',
    content: `For projects to be realised — attach to the form:
· Descriptive concept (max 3,000 characters)
· Renders, sketches or technical drawings
· Technical sheet: dimensions, materials, installation method, requirements
· Indicative production budget (if applicable)
· Feasibility statement
Accepted formats: PDF, JPG, PNG, mp3, mp4 (max 10MB per file)

For completed works — attach to the form:
· Work description (max 2,000 characters): title, year, concept, context
· Professional photographic documentation (minimum 3 high-resolution images)
· Technical sheet: dimensions, materials, weight, transport and installation method
· Conservation conditions and any special exhibition requirements
Accepted formats: JPG, PNG, mp3, mp4 (min. 300dpi, max 10MB per file)

For site-specific / Land Art interventions:
· Indicate whether a preliminary site visit is required
· Map/plan of the intervention in the site context
· Environmental impact documentation (preferably reversible or compostable)
· Any necessary permits

For performances:
· Script/dramaturgy (max 2,000 characters)
· Teaser video or documentation of previous performances (Vimeo/YouTube link)
· Technical rider: space, audio, lighting, duration requirements
· Number of proposed performances during the event`
  },
  {
    id: 'come',
    title: 'How to apply',
    content: `1. Complete the online form at www.ruraldesign.art with:
· Personal details (name, surname, date of birth, residence)
· Contacts (email, phone, website/portfolio, social)
· Participation type (individual/group)
· Category
· Title of the work/project
· Description and concept
· Attached files (images, renders, audio/video)

2. Attach the required materials following the technical specifications.

3. You will receive a confirmation email upon receipt of your application.`
  },
  {
    id: 'scadenze',
    title: 'Key deadlines',
    content: `11 JULY 2026, 23:59 — Application deadline (CET)
20 JULY 2026 — Selected artists announcement
3 AUGUST 2026 — Delivery and installation of works
8–21 AUGUST 2026 — Rural Design Amiata 2026`
  },
  {
    id: 'selezione',
    title: 'Selection process',
    content: `Works will be selected by the Rural Design Amiata curatorial team based on:
· Coherence with the theme "Heavy Weather / Intemperie"
· Artistic and project quality
· Originality and ability to question the present
· Technical and logistical feasibility
· Dialogue with the territory and the Parco delle Miniere locations
· Potential impact on the audience and community

Selected artists will be notified by 20 July 2026 via the website, social channels and direct email.`
  },
  {
    id: 'offriamo',
    title: 'What we offer',
    content: `For all selected artists:
✓ Exhibition at the Parco Nazionale delle Miniere del Monte Amiata
✓ Publication in the official catalogue (print and digital edition)
✓ Visibility through Rural Design's communication channels
✓ Professional documentation of works during the event
✓ Networking with the artistic, curatorial and rural design community
✓ Insurance of works during the exhibition period

Support for realisation (where possible):
· Logistical support for installation
· Material contribution (for site-specific or new works)
· Travel/accommodation reimbursement (case by case)

These aspects will be agreed individually after the selection announcement.`
  },
  {
    id: 'location',
    title: 'Available locations',
    content: `Works may be exhibited in the following locations within the Parco Nazionale delle Miniere del Monte Amiata:
· Historic mining galleries
· Recovered industrial spaces
· Nature trails and forests
· Squares and public spaces in mining villages
· Indoor and outdoor exhibition structures

Location preferences may be indicated in the application form.`
  },
  {
    id: 'esclusione',
    title: 'Grounds for exclusion',
    content: `Projects will be automatically excluded if:
❌ They arrive after the deadline (11 July 2026, 23:59)
❌ They do not comply with the required technical specifications
❌ They are considered off-theme for the 2026 call "Heavy Weather / Intemperie"
❌ They contain copyrighted materials without a release
❌ They contain offensive, discriminatory or illegal content`
  },
  {
    id: 'diritti',
    title: 'Rights and use of works',
    content: `Authors retain full intellectual property of their works.

By participating, authors accept:
· Temporary exhibition of works for the duration of the event
· Use of images for non-commercial promotion by RU.DE., catalogue, website and social media, press materials

The organisation may NOT use works for commercial purposes, sell them to third parties, or modify them without written consent.

At the end of the event, works must be collected within 15 days of closure.`
  },
  {
    id: 'faq',
    title: 'FAQ',
    content: `Can I submit more than one work?
Yes, each applicant or group may propose one or more works.

Are there age limits?
No, the call is open to all.

Are there any costs?
Participation is free. Any production, transport and installation costs are the artist's responsibility, unless otherwise agreed after selection.

Can I submit a previously exhibited work?
No, only unpublished works are accepted.

Do I need to visit the locations before applying?
It is not mandatory. If selected, you can arrange a site visit with the organisation.

What if my work requires electricity or other technical support?
State it clearly in the technical sheet. The curatorial team will assess feasibility during selection.

Can I modify my application after submission?
You may send additions via email to cfa@ruraldesign.art before the 11 July deadline.

How will I know if my work has been selected?
You will receive an email by 20 July 2026. Names will also be published on the website and social channels.`
  },
];

export default function Regolamento() {
  const { lang } = useLang();
  const [open, setOpen] = useState(null);
  const sections = lang === 'it' ? sectionsIT : sectionsEN;
  const title = lang === 'it' ? 'Regolamento' : 'Guidelines';
  const subtitle = lang === 'it' ? 'Call for Artists 2026 — Heavy Weather / Intemperie' : 'Call for Artists 2026 — Heavy Weather / Intemperie';
  const backLabel = lang === 'it' ? '← Torna alla Call' : '← Back to Call';
  const formUrl = 'https://docs.google.com/forms/d/1FJ-Nqy9WEVEsxi-YzhiRXoleLhHoIS_WVPu2o9Z__9M/edit';
  const formLabel = lang === 'it' ? 'Partecipa ora →' : 'Apply now →';

  return (
    <div style={{ background: 'var(--white)', minHeight: '100vh', paddingTop: 'var(--nav-height)' }}>

      {/* Header rosso */}
      <div style={{ background: '#ED164E', padding: '80px 40px 60px', borderBottom: '2px solid rgba(255,255,255,0.2)' }}>
        <div style={{ maxWidth: '860px', margin: '0 auto' }}>
          <a href="/" style={{ fontFamily: 'var(--font-body)', fontSize: '11px', letterSpacing: '0.2em', color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', display: 'inline-block', marginBottom: '24px', transition: 'color 0.2s' }}
            onMouseEnter={e => e.target.style.color = 'var(--white)'}
            onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.6)'}
          >{backLabel}</a>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '10px', letterSpacing: '0.3em', color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', marginBottom: '16px' }}>
            {subtitle}
          </p>
          <h1 style={{ fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: 'clamp(2.5rem, 6vw, 5rem)', color: 'var(--white)', textTransform: 'uppercase', letterSpacing: '0.05em', lineHeight: 1, marginBottom: '32px' }}>
            {title}
          </h1>
          <a href={formUrl} target="_blank" rel="noopener noreferrer"
            style={{ display: 'inline-block', fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: '12px', letterSpacing: '0.2em', textTransform: 'uppercase', color: '#ED164E', background: 'var(--white)', padding: '14px 32px', transition: 'all 0.3s' }}
            onMouseEnter={e => { e.target.style.background = 'var(--black)'; e.target.style.color = 'var(--white)'; }}
            onMouseLeave={e => { e.target.style.background = 'var(--white)'; e.target.style.color = '#ED164E'; }}
          >{formLabel}</a>
        </div>
      </div>

      {/* Sezioni accordion */}
      <div style={{ maxWidth: '860px', margin: '0 auto', padding: '60px 40px' }}>
        {sections.map((s) => (
          <div key={s.id} style={{ borderBottom: '1px solid var(--gray)' }}>
            <button
              onClick={() => setOpen(open === s.id ? null : s.id)}
              style={{ width: '100%', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '24px 0', textAlign: 'left' }}
            >
              <span style={{ fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: 'clamp(0.9rem, 1.5vw, 1.1rem)', color: 'var(--black)', letterSpacing: '0.04em', textTransform: 'uppercase' }}>
                {s.title}
              </span>
              <span style={{ fontFamily: 'var(--font-title)', color: 'var(--red)', fontSize: '1.4rem', flexShrink: 0, marginLeft: '16px', transition: 'transform 0.3s', transform: open === s.id ? 'rotate(45deg)' : 'none', display: 'inline-block' }}>+</span>
            </button>
            {open === s.id && (
              <div style={{ paddingBottom: '28px', animation: 'fadeIn 0.3s ease' }}>
                {s.content.split('\n').map((line, i) => {
                  const isBold = line.startsWith('→') || line.startsWith('✓') || line.startsWith('❌');
                  const isEmpty = line === '';
                  return (
                    <p key={i} style={{
                      fontFamily: 'var(--font-body)', fontSize: '0.95rem', lineHeight: 1.8,
                      color: isBold ? '#222' : '#555',
                      fontWeight: isBold ? 700 : 400,
                      marginBottom: isEmpty ? '12px' : '2px',
                      paddingLeft: line.startsWith('·') || isBold ? '8px' : '0',
                    }}>{line}</p>
                  );
                })}
              </div>
            )}
          </div>
        ))}

        {/* CTA finale */}
        <div style={{ marginTop: '60px', padding: '40px', background: '#ED164E', textAlign: 'center' }}>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '11px', letterSpacing: '0.3em', color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', marginBottom: '16px' }}>
            {lang === 'it' ? 'La deadline è il 11 luglio 2026' : 'Deadline: 11 July 2026'}
          </p>
          <a href={formUrl} target="_blank" rel="noopener noreferrer"
            style={{ display: 'inline-block', fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: '13px', letterSpacing: '0.2em', textTransform: 'uppercase', color: '#ED164E', background: 'var(--white)', padding: '16px 40px', transition: 'all 0.3s' }}
            onMouseEnter={e => { e.target.style.background = 'var(--black)'; e.target.style.color = 'var(--white)'; }}
            onMouseLeave={e => { e.target.style.background = 'var(--white)'; e.target.style.color = '#ED164E'; }}
          >{formLabel}</a>
        </div>
      </div>

      <style>{`@keyframes fadeIn { from { opacity:0; transform:translateY(-8px); } to { opacity:1; transform:translateY(0); } }`}</style>
    </div>
  );
}
